import { Switch } from "@ui/switch";

interface Props {
  activeClassName?: string;
  defaultChecked?: boolean;
  checked?: boolean;
  onCheckedChange?: (state: boolean) => void;
  width?: string;
  height?: string;
  //  thumbSize?: number;
}
export const BasicSwitch = ({
  activeClassName,
  defaultChecked = false,
  checked,
  onCheckedChange,
  width,
  height,
}: Props) => {
  return (
    <Switch
      className={`${activeClassName} ${width} ${height}`}
      defaultChecked={defaultChecked}
      checked={checked}
      onCheckedChange={onCheckedChange}
      dir="ltr"
    />
  );
};
